export default __webpack_public_path__ + "static/media/evenshot.ba817615.png";